export default `float e, s=6., u=0.0;
  for(int j=0;j++<7;p=mod(p+1.,2.)-1.)
    s/=u=dot(p,p),
    p/=u;
  return e=dot(p,p)/s-abs(p.y)/s;
}`